import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export function LoggedOutPage() {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div className="nx-login">
      <div className="nx-login__stage">
        <div className="nx-login__card">
          <h1 className="nx-login__title">Você saiu do Volt</h1>
          <p className="nx-login__hint">Pode fechar esta aba e continuar no NxNet.</p>
          <p className="nx-login__hint" style={{ marginTop: 'var(--nx-space-4)' }}>
            <Link to="/login">Entrar de novo com e-mail e senha</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
